<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
</script>

<template>
    <div
        class="tw-h-[336px] tw-w-full tw-overflow-x-scroll lg:tw-overflow-x-auto tw-bg-primary-200"
    >
        <div
            class="tw-flex tw-w-max max-container tw-justify-center tw-items-start tw-gap-[100px] tw-pt-[60px]"
        >
            <HomeStepIcon
                :num="1"
                text="Registrarse (opcional)"
                icon="person"
            />
            <HomeStepIcon :num="2" text="Buscar productos" icon="search" />
            <HomeStepIcon
                :num="3"
                text="Añadir al carrito"
                icon="shopping_cart"
            />
            <HomeStepIcon
                :num="4"
                text="Definir método de pago y datos del comprador"
                icon="attach_money"
            />
            <HomeStepIcon
                :num="5"
                text="Definir método de entrega y datos del beneficiario"
                icon="local_shipping"
            />
            <HomeStepIcon
                :num="6"
                text="Completar pago de los productos"
                icon="done_all"
                isFinalStep
            />
        </div>
    </div>
</template>

<style></style>
